import api from "./api";
import endpoints from "./endpoints";

export default {
  suggest: {
    globalAttributes: {
      value: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.globalAttributeValue.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.globalAttributeValueUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.globalAttributeValueAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.globalAttributeUnitUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unit: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.globalAttributeUnit.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.globalAttributeUnitAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      }
    },
    invariantAttributes: {
      value: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeValue.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeValueUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeValueAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeUnitUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unit: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeUnit.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeUnitAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      }
    },
    variantAttributes: {
      value: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeValue.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeValueUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeValueAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeUnitUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unit: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeUnit.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.attributeUnitAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      }
    },
    erpAttributes: {
      value: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.erpAttributeValue.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.erpAttributeValueUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      valueAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.erpAttributeValueAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitUid: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.erpAttributeUnitUid.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unit: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.erpAttributeUnit.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      },
      unitAbbreviation: {
        get: async function (language, attributeId, filter, resultCount, disableNonDefaultSuggestions) {
          const response = await api.get(endpoints.suggests.erpAttributeUnitAbbreviation.get, {
            params: { language, attributeId, filter, resultCount, disableNonDefaultSuggestions }
          });
          return response.data;
        }
      }
    },
    catalogs: {
      category: {
        get: async function (languageCode) {
          const response = await api.get(endpoints.catalogs.categoris.get, {
            params: { languageCode }
          });
          return response.data.map((x) => ({
            value: x
          }));
        }
      }
    }
  }
};
